import {
  PAGE_ROUTE_ABOUT_PRODUCT,
  PAGE_ROUTE_LEARN_MORE_CATEGORIES,
  PAGE_ROUTE_LEARN_MORE_BENEFITS,
  PAGE_ROUTE_LEARN_MORE_FINANCE,
  PAGE_ROUTE_LEARN_MORE_INDUSTRIES,
  PAGE_ROUTE_LEARN_MORE_INVENTORY,
  PAGE_ROUTE_LEARN_MORE_OPERATIONS,
  PAGE_ROUTE_LEARN_MORE_OVERVIEW,
  PAGE_ROUTE_LEARN_MORE_PLATFORM,
  PAGE_ROUTE_LEARN_MORE_REGIONS,
  PAGE_ROUTE_LEARN_MORE_TEAM
} from "@kivunova/kivufrontendcommon";
import type { LearnMoreHubCategory } from "../types";

export const LEARN_MORE_HUB_CATEGORIES: LearnMoreHubCategory[] = [
  {
    id: "getting-started",
    titleKey: "learn-more-hub-category-getting-started",
    titleFallback: "Getting started",
    entries: [
      {
        id: "overview",
        route: PAGE_ROUTE_LEARN_MORE_OVERVIEW,
        titleKey: "learn-more-hub-entry-overview-title",
        titleFallback: "What Kivunova FMS does",
        descriptionKey: "learn-more-hub-entry-overview-description",
        descriptionFallback:
          "What the system is, why businesses use it, and what you can manage."
      },
      {
        id: "regions",
        route: PAGE_ROUTE_LEARN_MORE_REGIONS,
        titleKey: "learn-more-hub-entry-regions-title",
        titleFallback: "Regions, languages, and currency",
        descriptionKey: "learn-more-hub-entry-regions-description",
        descriptionFallback:
          "Availability in Rwanda and the region, languages, and local currency."
      }
    ]
  },
  {
    id: "daily-work",
    titleKey: "learn-more-hub-category-daily-work",
    titleFallback: "Daily operations",
    entries: [
      {
        id: "inventory",
        route: PAGE_ROUTE_LEARN_MORE_INVENTORY,
        titleKey: "learn-more-hub-entry-inventory-title",
        titleFallback: "Products and stock",
        descriptionKey: "learn-more-hub-entry-inventory-description",
        descriptionFallback:
          "Catalog products, stock in each store, and selling rules."
      },
      {
        id: "about-product",
        route: PAGE_ROUTE_ABOUT_PRODUCT,
        titleKey: "learn-more-hub-entry-about-product-title",
        titleFallback: "Products vs. product items",
        descriptionKey: "learn-more-hub-entry-about-product-description",
        descriptionFallback:
          "Understand catalog listings versus the stock available in each store."
      },
      {
        id: "categories",
        route: PAGE_ROUTE_LEARN_MORE_CATEGORIES,
        titleKey: "learn-more-hub-entry-categories-title",
        titleFallback: "Categories and subcategories",
        descriptionKey: "learn-more-hub-entry-categories-description",
        descriptionFallback:
          "How parent and child categories organize your catalog, with a paint-shop example."
      },
      {
        id: "operations",
        route: PAGE_ROUTE_LEARN_MORE_OPERATIONS,
        titleKey: "learn-more-hub-entry-operations-title",
        titleFallback: "Stores, customers, and orders",
        descriptionKey: "learn-more-hub-entry-operations-description",
        descriptionFallback:
          "Branches, customer and supplier records, and sales flow."
      },
      {
        id: "finance",
        route: PAGE_ROUTE_LEARN_MORE_FINANCE,
        titleKey: "learn-more-hub-entry-finance-title",
        titleFallback: "Money and reports",
        descriptionKey: "learn-more-hub-entry-finance-description",
        descriptionFallback:
          "Invoices, payments, receipts, and business dashboards."
      }
    ]
  },
  {
    id: "people-platform",
    titleKey: "learn-more-hub-category-people-platform",
    titleFallback: "People and platform",
    entries: [
      {
        id: "team",
        route: PAGE_ROUTE_LEARN_MORE_TEAM,
        titleKey: "learn-more-hub-entry-team-title",
        titleFallback: "People and access",
        descriptionKey: "learn-more-hub-entry-team-description",
        descriptionFallback: "Roles, permissions, and who can invite staff."
      },
      {
        id: "platform",
        route: PAGE_ROUTE_LEARN_MORE_PLATFORM,
        titleKey: "learn-more-hub-entry-platform-title",
        titleFallback: "Plans, access, and help",
        descriptionKey: "learn-more-hub-entry-platform-description",
        descriptionFallback:
          "Subscriptions, security, Ask Teta, and where to get support."
      }
    ]
  },
  {
    id: "your-business",
    titleKey: "learn-more-hub-category-your-business",
    titleFallback: "Your business",
    entries: [
      {
        id: "industries",
        route: PAGE_ROUTE_LEARN_MORE_INDUSTRIES,
        titleKey: "learn-more-hub-entry-industries-title",
        titleFallback: "Who uses Kivunova FMS",
        descriptionKey: "learn-more-hub-entry-industries-description",
        descriptionFallback:
          "Retail, pharmacy, restaurants, and other real-world examples."
      },
      {
        id: "benefits",
        route: PAGE_ROUTE_LEARN_MORE_BENEFITS,
        titleKey: "learn-more-hub-entry-benefits-title",
        titleFallback: "Why it helps your business",
        descriptionKey: "learn-more-hub-entry-benefits-description",
        descriptionFallback:
          "Less manual work, clearer visibility, and room to grow."
      }
    ]
  }
];
